import { mainnet as _mainnet, zksync } from '@wagmi/core/chains';
import { getPublicClient, http } from '@wagmi/core';
import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import {
  injectedWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { defineChain } from 'viem';

const INFURA_URL =
  'https://mainnet.infura.io/v3/8c9e12008f284c1d8e44093cea14af67';

const mainnet = defineChain({
  ..._mainnet,
  rpcUrls: { default: { http: [INFURA_URL] } },
});

const projectId = 'cc8aef5fad63985030ea3e2e9eb0eb38';

const chains = [mainnet, zksync] as const;

export const wagmiConfig = getDefaultConfig({
  appName: 'Score',
  projectId,
  chains,
  // Drop metaMaskWallet: its module-init `isMetaMask(window.ethereum)` check
  // fails whenever another injected wallet (Phantom, Coinbase, Brave…) shares
  // window.ethereum, silently falling back to a WalletConnect QR instead of
  // opening the extension. Omitting it lets wagmi's EIP-6963 mipd discovery
  // create the real injected connector for MetaMask.
  // injectedWallet renders only when a provider is injected — that's what
  // makes the modal connectable inside mobile in-app dapp browsers (OKX,
  // MetaMask…), where the mobile UI never shows the EIP-6963 "Installed"
  // group and no extension discovery exists.
  wallets: [
    {
      groupName: 'Wallets',
      wallets: [injectedWallet, walletConnectWallet],
    },
  ],
  transports: {
    [mainnet.id]: http(INFURA_URL),
    [zksync.id]: http(),
  },
});

const mainnetClient = getPublicClient(wagmiConfig, { chainId: mainnet.id });
const zkClient = getPublicClient(wagmiConfig, { chainId: zksync.id });
// getPublicClient's `| undefined` is an artifact of the RainbowKit fork's
// getDefaultConfig erasing its chains generic to bare Config; both chains
// are configured above, so this guard is statically unreachable. It lifts
// with the fork swap — see the RainbowKit note in CLAUDE.md.
if (mainnetClient == null || zkClient == null) {
  throw new Error('wagmiConfig is missing a configured chain client');
}

export const mainnetPublicClient = mainnetClient;
export const zkPublicClient = zkClient;
